module.exports = __webpack_public_path__ + "612ce0de2613fec7fbaf88c9853f54fc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-1.png
// module id = 1162
// module chunks = 0